var map = {
	"./SkullRadio.svg": 1051,
	"./coinbaseWalletIcon.svg": 1052,
	"./discordlogo.svg": 323,
	"./fortmaticIcon.png": 1053,
	"./gridPlusWallet.png": 1054,
	"./metamask.png": 1055,
	"./metamask.svg": 1056,
	"./portisIcon.png": 1057,
	"./times-thin.svg": 79,
	"./toko.png": 1058,
	"./toko.svg": 84,
	"./tokogray.svg": 1059,
	"./tokomodal.svg": 1060,
	"./torusIcon.png": 1061,
	"./trustWallet.png": 1062,
	"./usdc.svg": 159,
	"./wallet.svg": 322,
	"./walletConnectIcon.svg": 1063
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1050;